module.exports = __webpack_public_path__ + "static/media/pdf.be6c9843.svg";